import { useTranslation } from 'react-i18next';
import { OrganizationDto } from '@sib/api';
import { tracking } from '@sib/tracking';
import { Button, Dialog, DialogContent } from '@sib/ui';
import { AskSpendBrain, X } from '@sib/ui/icons';
import { SPENDBRAIN_LEARN_MORE_URL } from '@spendbrain/config/constants';

interface ActivateAiModalProps {
  isOpen: boolean;
  onClose: () => void;
  organization?: OrganizationDto;
}

export const ActivateAiModal = ({
  isOpen,
  onClose,
  organization,
}: ActivateAiModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="flex max-h-[90vh] w-full max-w-[90vw] flex-col items-center gap-7 px-6 py-6 pb-10 sm:max-w-[70vw] sm:px-12 xl:max-w-[60vw]">
        <div className="flex w-full justify-end">
          <Button
            onClick={onClose}
            size="icon"
            variant="ghost"
            className="text-primary"
          >
            <X className="text-primary" />
          </Button>
        </div>
        <div className="flex flex-col items-center gap-7">
          <AskSpendBrain className="text-primary size-32" aria-hidden="true" />
          <div className="flex flex-col items-center gap-2">
            <h2 className="text-primary gap-2 text-center text-3xl font-semibold">
              {t('aiServiceModal.askSpendBrainModalTitle')}
            </h2>
            <p className="text-muted-foreground text-center text-sm leading-5 lg:max-w-[80%]">
              {t('aiServiceModal.askSpendBrainModalDescription')}
            </p>
          </div>
          <div className="flex items-center gap-4">
            {organization?.manager?.email && (
              <Button
                variant="outline"
                size="sm"
                color="primary"
                asChild
                onClick={() => tracking.track('Contact Team AI Member clicked')}
              >
                <a
                  href={`mailto:${organization.manager.email}?subject=${encodeURIComponent(
                    t('aiServiceModal.spendbrainActivationSubject')
                  )}`}
                >
                  {t('aiServiceModal.askSpendBrainContact')}
                </a>
              </Button>
            )}
            <Button
              size="sm"
              color="primary"
              asChild
              onClick={() => tracking.track('Learn more about AI clicked')}
            >
              <a
                href={SPENDBRAIN_LEARN_MORE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t('aiServiceModal.learnMore')}
              </a>
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
